export default Object.freeze({
  NotRequired: 1,
  AutomyApprovalRequired: 2,
});
